/*import logo from './logo.svg';*/
import React from "react";
import "./App.css";
import Home1 from "./pages/Home1";
//import Categories from './pages/Categories';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { apiResponse: "" };
  }
  render() {
    return (
      <div>
        <Home1 />
      </div>
    );
  }
}
export default App;
